export default __webpack_public_path__ + "media/images/wine-glass-b2a7a3b04931870d9853d7df884d6c96.png";